/**
 * Hevsel Bahcesi — GA4 event katmani (G-2RG1LDVSLV).
 * Tum gonderimler window.hbTrack uzerinden gecer; ileride GTM'e gecis
 * kararinda yalnizca bu fonksiyonun icini degistirmek yeterlidir.
 *
 * Liquid tarafindan beslenen veri bloklari:
 *   script[data-hb-list]    → view_item_list (koleksiyon / ana sayfa / oneriler)
 *   script[data-hb-product] → view_item + out_of_stock_view (urun sayfasi)
 *   script[data-hb-cart]    → view_cart + cart.js icin key→item haritasi
 *   [data-hb-search]        → search (terim, sonuc sayisi, sifir-sonuc bayragi)
 */
(function () {
  var CURRENCY = "TRY";
  var GA4_ID = "G-2RG1LDVSLV";

  function track(name, params) {
    if (typeof window.gtag !== "function") return;
    params = params || {};
    // send_to: eventlerimiz yalnizca kendi property'mize gider; sayfadaki
    // diger etiketlere (kanal uygulamasinin Ads tag'i vb.) sizmaz.
    params.send_to = GA4_ID;
    window.gtag("event", name, params);
  }
  window.hbTrack = track;

  function readJSON(el) {
    try {
      return JSON.parse(el.textContent);
    } catch (e) {
      return null;
    }
  }

  // variant_id -> item sozlugu. Sayfadaki tum Liquid veri bloklarindan beslenir ve
  // select_item ile add_to_cart bunu kullanir. Amac tek bir dogru kaynak: item_name
  // ve item_id her event'te ayni yerden gelsin. (Onceden select_item item_id olarak
  // urun handle'ini, add_to_cart ise /cart/add yanitindaki basligi gonderiyordu;
  // ikisi de diger event'lerle uyusmuyordu.)
  window.hbItemsById = window.hbItemsById || {};
  function indexItem(it) {
    if (!it || it.item_id === undefined || it.item_id === null) return;
    var key = String(it.item_id);
    if (!window.hbItemsById[key]) window.hbItemsById[key] = it;
  }

  function scanLists() {
    document
      .querySelectorAll("script[data-hb-list]:not([data-hb-done])")
      .forEach(function (el) {
        el.setAttribute("data-hb-done", "1");
        var items = readJSON(el);
        if (!items || !items.length) return;
        items.forEach(indexItem);
        track("view_item_list", {
          item_list_id: el.getAttribute("data-list-id") || undefined,
          item_list_name: el.getAttribute("data-list-name") || undefined,
          items: items,
        });
      });
  }
  // Sonradan DOM'a eklenen listeler (or. lazy-load onerileri) bu event ile taranir
  document.addEventListener("hb:scan", scanLists);

  document.addEventListener("DOMContentLoaded", function () {
    scanLists();

    // Urun sayfasi: view_item + tukendi gorunumu
    var productEl = document.querySelector("script[data-hb-product]");
    if (productEl) {
      var p = readJSON(productEl);
      if (p) {
        window.hbProduct = p;
        indexItem({
          item_id: p.item_id,
          item_name: p.item_name,
          price: p.price,
          item_variant: p.item_variant || undefined,
          item_category: p.item_category || undefined,
        });
        track("view_item", {
          currency: CURRENCY,
          value: p.price,
          items: [
            {
              item_id: p.item_id,
              item_name: p.item_name,
              price: p.price,
              item_variant: p.item_variant || undefined,
              item_category: p.item_category || undefined,
            },
          ],
        });
        if (p.available === false) {
          track("out_of_stock_view", {
            item_id: p.item_id,
            item_name: p.item_name,
          });
        }
      }
    }

    // Sepet sayfasi: view_cart + cart.js'in kullanacagi key→item haritasi
    var cartEl = document.querySelector("script[data-hb-cart]");
    if (cartEl) {
      var cart = readJSON(cartEl);
      if (cart && cart.items) {
        window.hbCartItems = {};
        cart.items.forEach(function (it) {
          window.hbCartItems[it.key] = it;
          indexItem({
            item_id: it.item_id,
            item_name: it.item_name,
            price: it.price,
          });
        });
        track("view_cart", {
          currency: CURRENCY,
          value: cart.value,
          items: cart.items.map(function (it) {
            return {
              item_id: it.item_id,
              item_name: it.item_name,
              price: it.price,
              quantity: it.quantity,
            };
          }),
        });
      }
    }

    // Arama sonuclari
    var searchEl = document.querySelector("[data-hb-search]");
    if (searchEl) {
      var count = Number(searchEl.getAttribute("data-count")) || 0;
      track("search", {
        search_term: searchEl.getAttribute("data-terms") || "",
        results_count: count,
        zero_results: count === 0,
      });
    }

    // Urun karti tiklamalari (tum kart varyantlarini tek delege listener kapsar).
    // Yalnizca bir liste blogunda yer alan kartlar sayilir: link bir [data-variant-id]
    // kartinin icinde olmali ve o varyant hbItemsById'de bulunmali. Boylece breadcrumb,
    // sepetteki urun adi ve urun sayfasi thumbnail'lari sayilmaz — bunlar select_item'i
    // view_item'in uzerine cikariyordu (28 Agu-1 Eyl 2026: 6.013 vs 5.050).
    document.addEventListener("click", function (e) {
      if (!e.target.closest) return;
      var a = e.target.closest('a[href*="/products/"]');
      if (!a) return;
      var card = a.closest("[data-variant-id]");
      if (!card) return;
      var item = window.hbItemsById[card.getAttribute("data-variant-id")];
      if (!item) return;
      track("select_item", {
        item_list_id: item.item_list_id || undefined,
        item_list_name: item.item_list_name || undefined,
        items: [item],
      });
    });

    // Yuksek niyet sinyalleri: WhatsApp (pestisit raporu) ve telefon
    document.addEventListener("click", function (e) {
      if (!e.target.closest) return;
      var a = e.target.closest(
        'a[href*="wa.me"], a[href*="api.whatsapp.com"], a[href^="tel:"]',
      );
      if (!a) return;
      var href = a.getAttribute("href") || "";
      track(href.indexOf("tel:") === 0 ? "phone_click" : "whatsapp_click", {
        link_url: href,
        page_path: location.pathname,
      });
    });
  });
})();
